/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../reducers';
import { selectList, loadSurveyList } from '../../slice/initiativeSurveyListSlice';
import LoadingPlaceholder from '../LoaderContainer/LoadingPlaceholder';
import { ReportSwitcherDropdown, ReportSwitcherDropdownProps } from './ReportSwitcherDropdown';
import './styles.scss';

export const ReportSwitcherContainer = (props: ReportSwitcherDropdownProps) => {
  const { initiativeId } = props;
  const { loaded } = useAppSelector(selectList);

  const dispatch = useDispatch();
  useEffect(() => {
    if (initiativeId) {
      dispatch(loadSurveyList(initiativeId));
    }
  }, [dispatch, initiativeId]);

  return <div className={'ml-2 flex-fill report-switcher-container'}>
    <LoadingPlaceholder height={38} isLoading={!loaded}>
      <ReportSwitcherDropdown {...props} />
    </LoadingPlaceholder>
  </div>
}
